function TextLink(props) {
  return (
    <a href={props.href} className="text-link" target={props.newTab ? '_blank' : null} rel="noreferrer">
      {props.children}
    </a>
  );
}

export default TextLink;
